// src/pages/benefits/ReccBenefitsCmsPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import DOMPurify from "dompurify";
import api from "../../api/axiosClient";

import LoadingComponent from "../../components/common/Loading";
import HTMLParser, { Element } from 'html-react-parser';


/** Single-page section but kept slug-friendly for future expansion */
const SLUGS = { recc: "recc" };

async function fetchCmsByPrefix(prefix, locale = "") {
  const params = { prefix };
  if (locale) params.locale = locale;
  const res = await api.get("/cms", { params });
  return res.data || {};
}

function decodeEntities(str) {
  if (typeof str !== "string") return "";
  const ta = document.createElement("textarea");
  ta.innerHTML = str;
  return ta.value;
}

function normalizeCmsHtml(val) {
  const raw = typeof val === "string" ? val : "";
  const looksEncoded = /&lt;|&gt;|&amp;|&quot;|&#39;|&#x[0-9A-Fa-f]+;/.test(raw);
  const decoded = looksEncoded ? decodeEntities(raw) : raw;
  return DOMPurify.sanitize(decoded);
}

function readText(obj, key, fallback = "") {
  const v = obj?.[key];
  if (typeof v === "string") return v;
  if (v && typeof v === "object" && "value" in v) return v.value ?? fallback;
  return fallback;
}

export default function ReccBenefitsCmsPage() {
  const { slug = "" } = useParams();
  const { pathname } = useLocation();

  const validSlug = SLUGS[slug] ? slug : "recc";
  const cmsKey = SLUGS[validSlug];
    const cmsPrefix = `benefits.${cmsKey}.`;
    //const cmsPrefix = `training.webinars.`;

  // canonical base
  const inCompany = pathname.startsWith("/company/");
  const inMember = pathname.startsWith("/member/");
  const baseRoot = inCompany ? "/company/benefits" : inMember ? "/member/benefits" : "/company/benefits";
  const needRedirect = slug !== validSlug;

  const [loading, setLoading] = useState(true);
  const [cms, setCms] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const data = await fetchCmsByPrefix(cmsPrefix);
          if (alive) {
              setCms(data || {});
          }
      } catch (e) {
        if (alive) setError(e?.response?.data?.message || "Failed to load content.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [cmsPrefix]);

    useEffect(() => {
        let t = readText(cms, `${cmsPrefix}body`, "");

        if (!t || !t.length || t.length <= 0)
            return;

        var sections = document.querySelectorAll(".cms-section.collapsible");
        if (sections.length <= 0)
            return;

        for (let jj = 0; jj < sections.length; jj++) {
            let section = sections[jj];

            let button = document.createElement('div');
            button.className = 'minmaxbtn';

            button.addEventListener('click', (e) => {
                //console.log("click", e);
                let parent = e.target.closest('.collapsible');
                if (parent)
                    parent.classList.toggle('closed');
            });

            section.appendChild(button);
        }
    }, [cms])

  if (needRedirect) return <Navigate to={`${baseRoot}/${validSlug}`} replace />;

  const title = readText(cms, `${cmsPrefix}title`, "RECC Benefits");
  const bodyHtml = normalizeCmsHtml(readText(cms, `${cmsPrefix}body`, ""));



    if (loading)
        return (
            <>
                <LoadingComponent></LoadingComponent>
            </>
        )


    return (
        <div className="cms-page recc">
            <div className="cms-header">
                <div className="cms-title">{title}</div>
            </div>

            <div className="cms-body">
                {bodyHtml ?
                    <>
                        {HTMLParser(bodyHtml)}
                    </>
                    :
                    <>
                        <div className="cms-section">
                            <div className="cms-greybox">
                                <h3>No content has been added for this section yet.</h3>
                            </div>
                        </div>
                    </>
                }

            </div>
        </div>
    )
}
